import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductWarrantyItemList } from 'src/app/models/product/productAssets.modal';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';

@Component({
  selector: 'app-add-product-warranty-service',
  templateUrl: './add-product-warranty-service.component.html',
  styleUrls: ['./add-product-warranty-service.component.css']
})
export class AddProductWarrantyServiceComponent implements OnInit {

  warrantyServiceItem: ProductWarrantyItemList = new ProductWarrantyItemList();
  Loader: boolean = false;
  selectedActiveValue: string;
  selectedActiveService: string;
  isActive: boolean = false;
  saveUsername: boolean;
  isSelected: boolean;
  isChecked
  ProductId: string;
  WarrantyId: string;
  price1: string;
  price2: string;
  price3: string;
  price4: string;
  price5: string;
  price6: string;
  value: string = "1";
  localStorageService: LocalstorageService;
  isQuote: boolean;

  constructor(private _warrantyServiceService: WarrantyServiceService, private modalService: NgbModal, private router: Router, private _localStorageService: LocalstorageService
  ) {

    this.localStorageService = _localStorageService;
  }

  ngOnInit() {
    this.WarrantyId = localStorage.getItem('WarrantyId');
    this.ProductId = localStorage.getItem('productId');
    this.addWarrantyService();
    this.isQuote = this.isQuote;
  }

  addWarrantyService() {
    this.Loader = true;
    this.warrantyServiceItem.warrantyId = +this.WarrantyId
    this._warrantyServiceService.AddProductWarrantyService(this.warrantyServiceItem)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.warrantyServiceItem = responseBody.responseData;
          setTimeout(() => {
            this.showFeatureEditorValue();
          }, 100);
          var durationWithPrizeList = JSON.parse(this.warrantyServiceItem.duration);
          for (var i = 0; i < durationWithPrizeList.length; i++) {
            if (durationWithPrizeList[i].Duration == "1") {
              this.price1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == "2") {
              this.price2 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == "3") {
              this.price3 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == "4") {
              this.price4 = durationWithPrizeList[i].Price;
            }
            else if (durationWithPrizeList[i].Duration == "5") {
              this.price5 = durationWithPrizeList[i].Price;
            }
            else {
              this.price6 = durationWithPrizeList[i].Price;
            }
          }
        }
      });
  }

  onSubmit() {
    this.warrantyServiceItem.duration = this.selectedActiveValue;
    var application = this.saveUsername;
    this.ProductId = this.ProductId;
    if (this.localStorageService.getToken()) {
      if (this.warrantyServiceItem.duration) {
        this.router.navigate(['/order-confirm/' + this.ProductId + '/' + this.WarrantyId + '/' + this.warrantyServiceItem.duration + '/' + application]);
      }
      else {
        this.router.navigate(['/order-confirm/' + this.ProductId + '/' + this.WarrantyId + '/' + 0 + '/' + 0]);
      }
    } else {
      if (!this.warrantyServiceItem.duration) {
        this.router.navigate(['/login'], { queryParams: { return: window.location.origin + "/#/order-confirm/" + this.ProductId + "/" + this.WarrantyId + "/0/0" } });
      }
      else {
        this.router.navigate(['/login'], { queryParams: { return: window.location.origin + "/#/order-confirm/" + this.ProductId + "/" + this.WarrantyId + "/" + this.warrantyServiceItem.duration + "/" + application } });
      }
    }

    this.modalService.dismissAll();
  }

  selectActive(selectedValue) {
    this.isActive = true;
    this.selectedActiveValue = selectedValue;
    this.onSaveUsernameChanged(this.value);

  }

  onSaveUsernameChanged(value) {
    this.saveUsername = value;
  }

  showFeatureEditorValue() {
    var featureElement: HTMLIFrameElement = document.getElementById('warrantyFeatures') as HTMLIFrameElement;
    featureElement.innerHTML = this.warrantyServiceItem.warrantyServiceTerm;
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  requestQuote() {
    this.router.navigate(['/request-quote/' + this.ProductId]);
    this.modalService.dismissAll();
  }

}
